import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { type FC } from 'react'
import { useMutation } from '@tanstack/react-query'
import userApi from '~/api/userApi'
import { showErrors } from '~/utils/helpers'

interface CaseDownloadButtonProps {
  courseId: string
  caseId: number
}

export const CaseDownloadButton: FC<CaseDownloadButtonProps> = ({
  courseId,
  caseId
}) => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async () => await userApi.getCaseDownloadUrl(courseId, caseId),
    retry: false,
    onSuccess: ({ data }) => { window.location.assign(data.url) },
    onError: showErrors
  })

  return (
        <Button
            type='primary'
            htmlType='button'
            aria-label='Download'
            title='Download'
            icon={<DownloadOutlined />}
            loading={isLoading}
            disabled={isLoading}
            onClick={() => { mutate() }}
        />
  )
}
